import { useUser } from '@folklore/auth';
import { parseISO } from 'date-fns/parseISO';

import useDocuments from './useDocuments';
import { useNotifications } from './useNotifications';

export function useAccountActivity({ days = 7 } = {}) {
    const { subscriptions: userSubscriptions = [] } = useUser() || {};

    const userSubscriptionsIds = (userSubscriptions || [])
        .filter(({ subscribed = false }) => subscribed)
        .map(({ id }) => id);

    const { items: lastSubscriptions = null, isLoading: lastSubscriptionsLoading } = useDocuments(
        {
            type: 'newsletter',
            last_from_subscription: userSubscriptionsIds,
            published_days: days,
        },
        {
            enabled: userSubscriptionsIds.length > 0,
        },
    );

    const { items: notifications = null, isLoading: notificationsLoading } = useNotifications({
        updated_days: days,
    });

    const finalItems = [
        ...(notifications || []).map((item) => ({
            id: item.id,
            type: 'notification',
            item,
            date: parseISO(item.date),
        })),
        ...(lastSubscriptions || []).map((item) => ({
            id: item.id,
            type: 'newsletter',
            item,
            date: parseISO(item.date),
        })),
    ].sort((a, b) => (a.date.getTime() > b.date.getTime() ? -1 : 1));

    return {
        items: finalItems,
        isLoading: lastSubscriptionsLoading || notificationsLoading,
    };
}
